var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[(_vm.name != '')?_c('div',{staticClass:"form-label"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.name))])]):_vm._e(),_c('div',{staticClass:"control"},[_vm._t("control")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }